import { NewsletterContentModule } from '@silvertours/common-landingpages-view';
import { useTranslations } from 'next-intl';

export const useNewsletterModuleDefaults = (): NewsletterContentModule => {
  const t = useTranslations(
    'features.newsletterRegistrationLegacy.newsletterRegistration',
  );

  return {
    moduleType: 'newsletterModule',
    badge: { text: t('badge') },
    heading: { text: t('title') },
  };
};
